<template>
  <v-container fluid>
    <v-card>
      <v-card-title>
        <v-row>
          <v-col>
            Steuern
          </v-col>
          <v-col>
            <v-text-field v-model="search" label="Suche">
              <v-icon slot="append">
                mdi-magnify
              </v-icon>
            </v-text-field>
          </v-col>
          <v-col>
            <v-btn color="primary">
              Hinzufügen
            </v-btn>
          </v-col>
        </v-row>
      </v-card-title>
      <v-data-table
        :headers="headers"
        :items="taxes"
        :search="search"
      >
        <template #[`item.created_at`]="{ item }">
          {{ getDateString(item.created_at) }}
        </template>
        <template #[`item.actions`]="{ item }">
          <!-- <Inertia-Link :href="route('tax.edit', item.id)">
                        <v-icon small>
                            mdi-pencil
                        </v-icon>
                    </Inertia-Link> -->

          <v-icon @click="deletePrompt(item)">
            mdi-delete
          </v-icon>
        </template>
      </v-data-table>
    </v-card>
    <!-- <v-dialog max-width="800" v-model="createItem">
            <BundleItemCreate
                :items="items"
                :bundle="bundle.id"
                @updated="updated()"
            ></BundleItemCreate>
        </v-dialog> -->
    <v-dialog v-model="editItem" max-width="800">
      <BundleItemCreate :tax="selectedItem" />
    </v-dialog>
  </v-container>
</template>

<script>
import Layout from '@/Layouts/Admin'
import { formattedDateTimeString } from '@/plugins/formatDate.js'

export default {
   name: 'SettingsTaxIndex',
   metaInfo () {
      // don't know your return object structure,
      // maybe you should check whole this.getViewPage
      return {
         title: this.title ? this.title : 'Optionen / Steuern'
      }
   },
   layout: (h, page) => h(Layout, [page]),
   props: {
      taxes: {
         type: Array,
         required: true
      }
   },
   data () {
      return {
         headers: [
            { text: 'Name', value: 'name' },
            { text: 'Prozente', value: 'percent' },
            { text: 'Erstellungsdatum', value: 'created_at' },
            { text: '', value: 'actions', sortable: false }
         ],
         search: null
      }
   },
   methods: {
      getDateString (dateVal) {
         return formattedDateTimeString(dateVal)
      }
   }
}
</script>

<style></style>
